import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { IAutomation } from '@kinet-open-network/shared/data-access/model';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FormlyFieldProps } from '@ngx-formly/primeng/form-field';
import { distinctUntilChanged, startWith } from 'rxjs';
import { AutomationTriggerContainerComponent } from './automation-trigger-container.component';
import { AutomationTriggerService } from './automation-trigger.service';

interface AutomationTriggerBuilderProps extends FormlyFieldProps {}

@Component({
  selector: 'kon-automation-trigger-builder-type',
  imports: [AutomationTriggerContainerComponent],
  providers: [AutomationTriggerService],
  template: `
    <kon-automation-trigger-container
      [automation]="automation()"
      (automationChange)="handleAutomationChange($event)"
    />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AutomationTriggerBuilderTypeComponent
  extends FieldType<FieldTypeConfig<AutomationTriggerBuilderProps>>
  implements OnInit
{
  readonly #destroyRef = inject(DestroyRef);
  readonly automation = signal<Partial<IAutomation>>({});

  ngOnInit() {
    this.formControl.parent?.valueChanges
      .pipe(
        takeUntilDestroyed(this.#destroyRef),
        startWith(this.formControl.parent?.value),
        distinctUntilChanged(),
      )
      .subscribe((value) => this.automation.set({ ...value }));
  }

  handleAutomationChange(automation: Partial<IAutomation>) {
    this.formControl.setValue(automation.triggerData || {});
  }
}
